import { render } from "./journal-v1.vue?vue&type=template&id=2fbbdf70&scoped=true"
import script from "./journal-v1.vue?vue&type=script&lang=js"
export * from "./journal-v1.vue?vue&type=script&lang=js"

import "./journal-v1.vue?vue&type=style&index=0&id=2fbbdf70&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbbdf70"]])

export default __exports__